export default {
  name: 'table-column-button',
  props: {
    text: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      required: true
    },
    stylingClasses: {
      type: String,
      default: ''
    }
  },
  data () {
    return {

    }
  },
  methods: {
    onClick () {
      this.$emit('click', this.index)
    }
  }
}
